<template>
	<div class="quote-card">
		<QuoteCardTitle class="mb-4">Analyst Ratings</QuoteCardTitle>

		<div class="lg:flex flex-row items-center gap-16 flex-wrap">
			<!-- Left: Strong Buy Circle -->
			<div class="flex-shrink-0 flex flex-col items-center mb-6 lg:mb-0">
				<div
					class="rounded-full bg-green-100 w-48 h-48 px-8 flex items-center bg-success/[0.1] justify-center"
				>
					<span
						class="text-success text-2xl lg:text-4xl font-medium text-center leading-tight text-wrap"
					>
						{{ ratingLabel }}
					</span>
				</div>
			</div>
			<!-- Right: Details -->
			<div class="flex-1">
				<div class="mb-2">
					<div class="text-lg lg:text-2xl text-black mb-1">
						Average Price Target: ${{ priceTarget }}
					</div>
					<div class="text-slate-500 text-sm lg:text-lg mb-6">
						Based on {{ totalRatings }} analyst ratings in the last 3 months
					</div>
				</div>
				<!-- Bars -->
				<div class="flex flex-col lg:flex-row lg:items-end gap-3 lg:gap-6 w-full">
					<!-- Sell -->
					<div class="flex flex-row items-center w-32 gap-3">
						<div
							class="w-full h-12 rounded-lg bg-red-500 mb-2"
							style="width: 80px"
						></div>
						<div>
							<div class="text-slate-400 text-base lg:text-lg">Sell</div>
							<div class="text-black text-base lg:text-2xl">{{ sell }}</div>
						</div>
					</div>
					<!-- Hold -->
					<div class="flex flex-row items-center w-32 gap-3">
						<div
							class="w-full h-12 rounded-lg bg-yellow-300 mb-2"
							style="width: 120px"
						></div>
						<div>
							<div class="text-slate-400 text-base lg:text-lg">Hold</div>
							<div class="text-black text-base lg:text-2xl">{{ hold }}</div>
						</div>
					</div>
					<!-- Buy -->
					<div class="flex flex-row items-center flex-1 gap-3">
						<div
							class="w-full h-12 rounded-lg bg-success mb-2"
							style="width: 200px"
						></div>
						<div>
							<div class="text-slate-400 text-base lg:text-lg">Buy</div>
							<div class="text-black text-base lg:text-2xl">
								{{ buy.toLocaleString() }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	ratingLabel: { type: String, default: "Strong Buy" },
	priceTarget: { type: [String, Number], required: true },
	totalRatings: { type: [String, Number], required: true },
	sell: { type: [String, Number], required: true },
	hold: { type: [String, Number], required: true },
	buy: { type: [String, Number], required: true }
});
</script>
